import React, { useState, useMemo } from "react";

// Hooks
import { useLeagueId } from "../hooks/useLeagueId";
import { useArmyboard } from "../hooks/useArmyboard";
import { useLeaderboard } from "../hooks/useLeaderboard";
import { useMatches } from "../hooks/useMatches";

// Utils
import { getArmyIcon } from "../util/getArmyIcon";

// Componentes
import Header from "./components/Header";
import DivisionTable from "./components/DivisionTable";
import LatestBattles from "./components/LatestBattles";
import FactionOnFire from "./components/FactionOnFire";
import PlayerPopup from "./PlayerPopup";

// Imágenes
import logo from "../img/COBRADOR_LEAGUE_LOGO_02_FINAL.png";
import vortem from "../img/vortem4.png";

// 💡 Tabs con ID y label visible
const phaseTabs = [
  { id: "phase1", label: "Phase I" },
  { id: "phase2a", label: "Phase II-a" },
  { id: "phase2b", label: "Phase II-b" },
  { id: "playoffs", label: "Play-offs" }
];

// 🎯 Textos por fase basados en ID (SEGUROS)
const phaseTexts = {
  phase1: {
    title: "El Velo de Sangre: Crónicas del Subsector Vortem",
    text: "El Subsector Vortem, antaño una región próspera del Segmentum Obscurus,\n ha sido desgarrado por la aparición de una grieta disforme conocida como el Velo de Sangre. Esta anomalía, surgida tras una tormenta warp sin precedentes, ha alterado la realidad misma en varios sistemas planetarios, provocando mutaciones, desapariciones masivas y el colapso de las comunicaciones astropáticas. El Imperio ha declarado el subsector como Zona de Guerra Prioritaria, pero sus fuerzas están fragmentadas. Mientras tanto, otras facciones han detectado la inestabilidad y han acudido con sus propias agendas: algunos buscan poder, otros venganza, otros simplemente sobrevivir.El conflicto no es solo militar: es espiritual, ideológico y existencial. El Velo de Sangre no solo distorsiona la materia, sino también la voluntad. Las alianzas se rompen, los líderes enloquecen, y los planetas cambian de manos en cuestión de días."
  },
  phase2a: {
    title: "La Tormenta Crece",
    text: 
`El Subsector Vortem, antaño una región próspera del Segmentum Obscurus, ha sido desgarrado por la aparición de una grieta disforme conocida como el Velo de Sangre. Esta anomalía, surgida tras una tormenta warp sin precedentes, ha alterado la realidad misma en varios sistemas planetarios, provocando mutaciones, desapariciones masivas y el colapso de las comunicaciones astropáticas.

El Imperio ha declarado el subsector como Zona de Guerra Prioritaria, pero sus fuerzas están fragmentadas. Mientras tanto, otras facciones han detectado la inestabilidad y han acudido con sus propias agendas: algunos buscan poder, otros venganza, otros simplemente sobrevivir.

El conflicto no es solo militar: es espiritual, ideológico y existencial. El Velo de Sangre no solo distorsiona la materia, sino también la voluntad. Las alianzas se rompen, los líderes enloquecen, y los planetas cambian de manos en cuestión de días.`

  },
  phase2b: {
    title: "Ecos del Disforme",
    text: "Texto para Phase II-b..."
  },
  playoffs: {
    title: "Clímax del Conflicto",
    text: "Texto final para los Play-offs..."
  }
};

const HomeWH40K = () => {
  const idleague = useLeagueId();
  console.log("idleague:", idleague);
  const [menuOpen, setMenuOpen] = useState(false);

  // 🆕 Ahora usamos un ID seguro como valor inicial
  const [activeTab, setActiveTab] = useState("phase1");

  const [selectedPlayer, setSelectedPlayer] = useState(null);

  const { factions } = useArmyboard(idleague);
  const { divisions } = useLeaderboard(idleague);
  const { data: lastMatches = [], isLoading, isError } = useMatches(idleague);

  const { topArmy, TopArmyIcon } = useMemo(() => {
    if (!factions?.length) return { topArmy: null, TopArmyIcon: null };

    const army = [...factions]
      .flatMap(f => f.armies)
      .sort((a, b) => b.points - a.points)[0];

    return {
      topArmy: army,
      TopArmyIcon: army ? getArmyIcon(army.army_name) : null,
    };
  }, [factions]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      <Header
        logo={logo}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        idleague={idleague}
      />

      {/* INTRO QUE CAMBIA POR FASE */}
      <div className="w-full flex flex-col md:flex-row items-start p-4 space-y-4 md:space-y-0 md:space-x-4">
        <div className="w-full md:w-1/3">
          <img src={vortem} alt="Subsector Vortem" className="w-full h-80 object-contain" />
        </div>

        <div className="w-full md:w-2/3 h-auto md:h-80 bg-gray-800 rounded-lg shadow-lg p-4 flex flex-col items-center">
          <h2 className="text-white text-2xl font-bold mb-2">
            {phaseTexts[activeTab].title}
          </h2>

          <p className="text-white text-lg font-normal">
            {phaseTexts[activeTab].text}
          </p>
        </div>
      </div>

      {/* MAIN GRID */}
      <div className="flex-1 p-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">

        {/* Pasamos los tabs como objetos con ID */}
        <DivisionTable
          divisions={divisions}
          phaseTabs={phaseTabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSelectedPlayer={setSelectedPlayer}
        />

        {isLoading ? (
          <div className="text-center text-gray-400">Loading matches...</div>
        ) : isError ? (
          <div className="text-center text-red-400">Error loading matches.</div>
        ) : (
          <LatestBattles lastMatches={lastMatches} />
        )}

        <FactionOnFire factions={factions} TopArmyIcon={TopArmyIcon} />
      </div>

      {selectedPlayer && (
        <PlayerPopup
          player={selectedPlayer}
          league={idleague}
          onClose={() => setSelectedPlayer(null)}
        />
      )}
    </div>
  );
};

export default HomeWH40K;
